import React from 'react';
import moment from 'moment/moment';
import { useTranslation } from 'react-i18next';

import {
  Form,
  ButtonsWrapper,
  Button,
  TextInput,
  SelectInput,
  DatePickerInput,
} from '@thinknet-gmbh/platform-common-ui';

import { useGetAllProcessTemplateForList } from 'src/hooks/process-task-templates/get-process-tasks-templates.hook';
import { useCreateProcess } from 'src/hooks/processes/create-process.hook';

const ProcessesForm = ({ onCancel, memberId }: { onCancel: () => void, memberId: string }) => {
  const [form] = Form.useForm();
  const { t, i18n } = useTranslation(['common', 'employee']);

  const { collection } = useGetAllProcessTemplateForList();

  const { createProcess, loading } = useCreateProcess({ onSuccess: onCancel });

  const onFinish = ({ startDate, ...doc }: any) => {
    createProcess({
      variables: {
        payload: { ...(startDate && { startDate: startDate.toDate() }), ...doc, memberId },
      },
    });
  }


  return (
    <Form layout="vertical" initialValues={{}} form={form} onFinish={onFinish}>
      <Form.Item
        name="title"
        label={t('employee:process.labels.name')}
        rules={[{ required: true, message: t('employee:process.validation.processNameRequired') }]}
      >
        <TextInput placeholder={t('employee:process.labels.enterName')} maxLength={50} />
      </Form.Item>

      <Form.Item
        name="taskTemplateId"
        label={t('employee:process.labels.processTemplate')}
        rules={[{ required: true, message: t('employee:process.validation.templateRequired') }]}
      >
        <SelectInput placeholder={t('employee:process.labels.processTemplate')}>
          {collection?.map(({ _id, name }: any) => (
            <SelectInput.Option key={_id} value={_id}>
              {name}
            </SelectInput.Option>
          ))}
        </SelectInput>
      </Form.Item>

      <Form.Item
        name="startDate"
        label={t('employee:process.labels.startDate')}
        rules={[{ required: true, message: t('employee:process.validation.startDateRequired') }]}
      >
        <DatePickerInput
          disabledDate={current => {
            const today = moment().startOf('day');

            return current && current.valueOf() < today.valueOf();
          }}
          lang={i18n.language}
          format="DD.MM.YYYY"
        />
      </Form.Item>

      <ButtonsWrapper marginTop={16}>
        <Button type="primary" htmlType="submit" disabled={loading}>
          {t('common:buttons.save')}
        </Button>
        <Button onClick={onCancel}>{t('common:buttons.cancel')}</Button>
      </ButtonsWrapper>
    </Form>
  );
};

export default ProcessesForm;
